export default __webpack_public_path__ + "static/media/cp-themeA.b17f61b1.png";